// extracted by mini-css-extract-plugin
export default {"form":"NovoServico_form__nkRsD","areaBtn":"NovoServico_areaBtn__Ij2BY","btn":"NovoServico_btn__MZ4Mh","btn2":"NovoServico_btn2__Wy2os"};